import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { CardUser } from './CardUser';

interface IDialogBox {
    status: boolean;
    handle: () => void;
}

export function DialogBox(props: IDialogBox) {
  
  const descriptionElementRef = React.useRef<HTMLElement>(null);
  React.useEffect(() => {
    if (props.status) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [props.status]);

  return (
    <div>
      <Dialog
        open={props.status}
        onClose={props.handle}
        scroll='paper'
        aria-labelledby="terms"
        aria-describedby="terms"
      >
        <DialogTitle id="scroll-dialog-title">Termos e Condições</DialogTitle>
        <DialogContent dividers={true}>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
          >
            <p>Lorem ipsum dolor sit amet. Sit reprehenderit saepe aut voluptatibus
               excepturi et suscipit autem nam distinctio earum est perferendis 
               aspernatur ut minima iusto sed sequi quibusdam. Non sint rerum qui
               voluptates corrupti et impedit alias non consectetur asperiores. Et
               praesentium iure et  nihil ea nisi quaerat ut modi mollitia. </p>
            <p>Qui provident dolorem  rerum architecto est minus sunt qui consequatur 
               ratione. In animi quia aut maxime sint qui temporibus officia qui rerum
               quod et officia soluta. Et repellendus quis et sunt consectetur in sint 
               dolore aut sint delectus sed soluta delectus. </p>
               <ul>
                <li>Qui culpa delectus rem quae necessitatibus id 
                   commodi accusantium ab amet vero. 
                </li>
                <li>Non pariatur tempora qui rerum porro in veniam delectus. 
                </li>
                <li>In nihil ipsum ea sequi dolorem non consequatur adipisci aut quos rerum. 
                </li>
                </ul>
                <p>In quasi soluta quo fugit aperiam aut tempora eaque non perferendis iusto
                  . Aut aliquam impedit qui quia quae qui natus molestiae est nisi illum et 
                  galisum placeat et consequuntur rerum et nesciunt doloribus. Et veniam 
                  accusantium 33 quisquam voluptatem sit dolores ullam aut debitis maxime 
                  vel fugiat rerum eos nesciunt  eum quisquam facilis. 
                </p>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={props.handle}>Fechar</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}